module.exports = __webpack_public_path__ + "img/InPersonEvent.eb000724.svg";